
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/info/cgu",
      function () {
        return require("private-next-pages/info/cgu.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/info/cgu"])
      });
    }
  